export const isFoundInEnum = (
    value: string,
    enumType: Record<string, string>,
) => {
    const isFound = Object.values(enumType).includes(value);

    return isFound;
};
